import React from 'react'
import PropTypes from 'prop-types'

const Svg = ({ style, className }) => (
	<svg
		width="100"
		height="100"
		viewBox="0 0 100 100"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={style}
		className={className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M39.1584 24.4876H66.5319C67.4625 24.4876 68.3549 24.8572 69.0128 25.5152C69.6708 26.1732 70.0404 27.0656 70.0404 27.9961V70.7923H39.1584V24.4998V24.4876Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M38.4084 24.4876C38.4084 24.0734 38.7442 23.7376 39.1584 23.7376H66.5319C67.6614 23.7376 68.7445 24.1862 69.5432 24.9849C70.3418 25.7835 70.7904 26.8666 70.7904 27.9961V70.7923C70.7904 71.2065 70.4546 71.5423 70.0404 71.5423H39.1584C38.7442 71.5423 38.4084 71.2065 38.4084 70.7923V24.4876ZM39.9084 25.2376V70.0423H69.2904V27.9961C69.2904 27.2645 68.9998 26.5628 68.4825 26.0455C67.9652 25.5282 67.2635 25.2376 66.5319 25.2376H39.9084Z"
			fill="#333333"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M29.51 30.2741H60.7453C62.6547 30.2805 64.2084 31.8126 64.2416 33.7217V76.5788H33.0185C31.0808 76.5788 29.51 75.008 29.51 73.0704V30.2741H29.51Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M28.76 30.2741C28.76 29.8599 29.0958 29.5241 29.51 29.5241H60.7478C63.0653 29.5318 64.9512 31.3915 64.9915 33.7087L64.9917 33.7217L64.9916 76.5788C64.9916 76.9931 64.6558 77.3288 64.2416 77.3288H33.0185C30.6666 77.3288 28.76 75.4223 28.76 73.0704V30.2741ZM30.26 31.0241V73.0704C30.26 74.5938 31.495 75.8288 33.0185 75.8288H63.4916V33.7285C63.4623 32.2308 62.2426 31.0297 60.744 31.0241H30.26Z"
			fill="#333333"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M34.5466 38.9855C34.5466 38.019 35.3301 37.2355 36.2966 37.2355H49.7315C50.698 37.2355 51.4815 38.019 51.4815 38.9855V44.709C51.4815 45.6755 50.698 46.459 49.7315 46.459H36.2966C35.3301 46.459 34.5466 45.6755 34.5466 44.709V38.9855ZM36.2966 38.7355C36.1586 38.7355 36.0466 38.8474 36.0466 38.9855V44.709C36.0466 44.8471 36.1586 44.959 36.2966 44.959H49.7315C49.8696 44.959 49.9815 44.8471 49.9815 44.709V38.9855C49.9815 38.8474 49.8696 38.7355 49.7315 38.7355H36.2966Z"
			fill="#333333"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M53.8434 39.9225C53.8434 39.5083 54.1792 39.1725 54.5934 39.1725H60.3921C60.8063 39.1725 61.1421 39.5083 61.1421 39.9225C61.1421 40.3367 60.8063 40.6725 60.3921 40.6725H54.5934C54.1792 40.6725 53.8434 40.3367 53.8434 39.9225Z"
			fill="#333333"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M53.8434 45.709C53.8434 45.2948 54.1792 44.959 54.5934 44.959H60.3921C60.8063 44.959 61.1421 45.2948 61.1421 45.709C61.1421 46.1233 60.8063 46.459 60.3921 46.459H54.5934C54.1792 46.459 53.8434 46.1233 53.8434 45.709Z"
			fill="#333333"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M34.5466 51.4956C34.5466 51.0814 34.8824 50.7456 35.2966 50.7456H59.4175C59.8317 50.7456 60.1675 51.0814 60.1675 51.4956C60.1675 51.9098 59.8317 52.2456 59.4175 52.2456H35.2966C34.8824 52.2456 34.5466 51.9098 34.5466 51.4956Z"
			fill="#333333"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M34.5466 57.2822C34.5466 56.868 34.8824 56.5322 35.2966 56.5322H59.4175C59.8317 56.5322 60.1675 56.868 60.1675 57.2822C60.1675 57.6964 59.8317 58.0322 59.4175 58.0322H35.2966C34.8824 58.0322 34.5466 57.6964 34.5466 57.2822Z"
			fill="#333333"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M34.5466 63.0809C34.5466 62.6667 34.8824 62.3309 35.2966 62.3309H59.4175C59.8317 62.3309 60.1675 62.6667 60.1675 63.0809C60.1675 63.4951 59.8317 63.8309 59.4175 63.8309H35.2966C34.8824 63.8309 34.5466 63.4951 34.5466 63.0809Z"
			fill="#333333"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M34.5466 68.8675C34.5466 68.4533 34.8824 68.1175 35.2966 68.1175H46.8819C47.2962 68.1175 47.6319 68.4533 47.6319 68.8675C47.6319 69.2817 47.2962 69.6175 46.8819 69.6175H35.2966C34.8824 69.6175 34.5466 69.2817 34.5466 68.8675Z"
			fill="#333333"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M51.4991 26.4124C51.7917 26.1579 51.9597 25.7891 51.9597 25.4012C51.9597 25.0134 51.7917 24.6446 51.4991 24.3901L43.3126 17.3001C42.9067 16.9681 42.3435 16.906 41.8751 17.1417C41.3996 17.3606 41.095 17.8364 41.0954 18.3599V20.6258C34.4408 20.6226 28.0577 23.2638 23.351 27.9682C18.6444 32.6726 16 39.0544 16 45.709V46.6714L17.8273 43.5771C22.6771 35.332 31.5297 30.2707 41.0954 30.2741V32.5035C41.0962 33.0277 41.4025 33.5033 41.8794 33.7208C42.3564 33.9383 42.9163 33.8577 43.3126 33.5146L51.4991 26.4124Z"
			fill="#B29EFA"
			className="u-scheme-color"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M41.5497 16.4659C42.2803 16.104 43.1557 16.2028 43.7874 16.7195L43.8036 16.7331L51.9912 23.8242C52.4477 24.2212 52.7097 24.7964 52.7097 25.4012C52.7097 26.0061 52.4477 26.5813 51.9912 26.9783L43.8041 34.0811C43.186 34.6163 42.3121 34.7424 41.5682 34.4032C40.8244 34.0639 40.3466 33.3221 40.3454 32.5046L40.3454 32.5035V31.0346C31.3346 31.2881 23.0618 36.1573 18.4738 43.9574L16.6458 47.0528C16.4739 47.3439 16.1285 47.484 15.8023 47.3949C15.4762 47.3058 15.25 47.0095 15.25 46.6714V45.709C15.25 38.8555 17.9734 32.2828 22.8208 27.4378C27.491 22.7698 33.7639 20.0742 40.3454 19.8863V18.3605M42.8312 17.8753C42.6551 17.7355 42.4135 17.7104 42.2122 17.8117C42.2044 17.8156 42.1966 17.8193 42.1887 17.823C41.9793 17.9194 41.8453 18.1289 41.8454 18.3594V20.6258C41.8454 20.8248 41.7664 21.0156 41.6256 21.1563C41.4849 21.2969 41.294 21.3759 41.0951 21.3758C34.6394 21.3727 28.4471 23.935 23.8812 28.4987C19.7676 32.6103 17.2779 38.0427 16.825 43.7996L17.1809 43.1969C17.181 43.1967 17.1808 43.1971 17.1809 43.1969C22.1655 34.7229 31.2643 29.5207 41.0957 29.5241C41.5098 29.5243 41.8454 29.86 41.8454 30.2741V32.5024C41.8458 32.7332 41.9806 32.9426 42.1906 33.0384C42.4004 33.134 42.6466 33.0988 42.8211 32.9481C42.8213 32.9479 42.8209 32.9483 42.8211 32.9481L51.0069 25.8465C51.0071 25.8463 51.0067 25.8466 51.0069 25.8465C51.1354 25.7344 51.2097 25.5718 51.2097 25.4012C51.2097 25.2308 51.136 25.0687 51.0076 24.9567C51.0074 24.9565 51.0079 24.9569 51.0076 24.9567L42.8312 17.8753Z"
			fill="#333333"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M48.4607 74.2591C48.168 74.5136 48 74.8824 48 75.2702C48 75.658 48.168 76.0268 48.4607 76.2813L56.6471 83.3714C57.053 83.7034 57.6162 83.7654 58.0846 83.5298C58.5602 83.3108 58.8647 82.835 58.8643 82.3115L58.8643 80.0456C65.5189 80.0489 71.902 77.4076 76.6087 72.7032C81.3154 67.9989 83.9597 61.617 83.9597 54.9624L83.9597 54L82.1324 57.0943C77.2826 65.3394 68.43 70.4007 58.8643 70.3973L58.8643 68.168C58.8635 67.6438 58.5572 67.1682 58.0803 66.9507C57.6034 66.7332 57.0434 66.8137 56.6471 67.1568L48.4607 74.2591Z"
			fill="#B29EFA"
			className="u-scheme-color"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M58.41 84.2056C57.6794 84.5675 56.804 84.4687 56.1723 83.9519L56.1561 83.9383L47.9685 76.8472C47.5121 76.4503 47.25 75.8751 47.25 75.2702C47.25 74.6653 47.5121 74.0901 47.9685 73.6932L56.1556 66.5903C56.7737 66.0552 57.6476 65.9291 58.3915 66.2683C59.1353 66.6075 59.6131 67.3493 59.6143 68.1668L59.6143 68.1679L59.6143 69.6369C68.6251 69.3833 76.8979 64.5142 81.4859 56.714L83.3139 53.6186C83.4858 53.3275 83.8313 53.1874 84.1574 53.2765C84.4835 53.3656 84.7097 53.6619 84.7097 54L84.7097 54.9624C84.7097 61.816 81.9863 68.3887 77.1389 73.2337C72.4687 77.9016 66.1958 80.5973 59.6143 80.7851L59.6143 82.311M57.1285 82.7961C57.3046 82.936 57.5462 82.9611 57.7476 82.8598C57.7553 82.8559 57.7631 82.8521 57.771 82.8485C57.9804 82.7521 58.1145 82.5426 58.1143 82.3121L58.1143 80.0456C58.1143 79.8467 58.1934 79.6558 58.3341 79.5152C58.4748 79.3745 58.6657 79.2955 58.8647 79.2956C65.3203 79.2988 71.5126 76.7365 76.0785 72.1728C80.1921 68.0612 82.6818 62.6287 83.1347 56.8719L82.7788 57.4745C82.7787 57.4747 82.7789 57.4744 82.7788 57.4745C77.7942 65.9485 68.6954 71.1508 58.864 71.1473C58.4499 71.1472 58.1143 70.8114 58.1143 70.3973L58.1143 68.1691C58.114 67.9383 57.9791 67.7288 57.7691 67.6331C57.5593 67.5374 57.3131 67.5727 57.1386 67.7233C57.1384 67.7235 57.1388 67.7232 57.1386 67.7233L48.9528 74.825C48.9527 74.8251 48.953 74.8248 48.9528 74.825C48.8243 74.937 48.75 75.0997 48.75 75.2702C48.75 75.4406 48.8237 75.6027 48.9521 75.7148C48.9523 75.715 48.9518 75.7145 48.9521 75.7148L57.1285 82.7961Z"
			fill="#333333"
		/>
	</svg>
)

Svg.propTypes = {
	style: PropTypes.string,
	className: PropTypes.string,
}

Svg.defaultProps = {
	style: null,
	className: null,
}

export default Svg
